import { DropdownSelectOptionType } from 'components'
import { TotalWatchColEnums } from 'pages/viewers/ViewerInfoPage/total-watch-columns'
import { TotalInteractionColEnums } from 'pages/viewers/ViewerInfoPage/total-interaction-columns'
import { TotalAddRevenueColEnums } from 'pages/viewers/ViewerInfoPage/total-add-revenue-columns'
import { TotalSpendColEnums } from 'pages/viewers/ViewerInfoPage/total-spend-columns'

export enum FilterEnums {
  PROJECT,
  PROJECT_TYPE,
  GENRE,
  BRAND,
  EVENT
}

export enum ViewerPageTabTypes {
  TOTAL_WATCH_VIDEO = 'Total watch time',
  TOTAL_INTERACTION_TIME = 'Total interaction time',
  ADD_REVENUE = 'Ad revenue',
  TOTAL_SPEND = 'Total spend'
}

export type Filters = { [key in FilterEnums]?: DropdownSelectOptionType[] }

export type ViewerPageColumnKeyTypes = TotalWatchColEnums[] |
TotalInteractionColEnums[] |
TotalAddRevenueColEnums[] |
TotalSpendColEnums[]

export type ViewerPageColumnKeys = {
  [key in ViewerPageTabTypes]: ViewerPageColumnKeyTypes
}
